export const mambaYandexMetrikaId = 23723584
